/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Stack, styled } from "@mui/material";
import { green, grey, yellow } from "@mui/material/colors";
import { StatusDot } from "../../../components";
import { AttendanceLogEntry, Child } from "../../../models";

const CalendarContainer = styled(Box)({});

// const StatusDot = styled(Box)({
//   backgroundColor: green[400],
//   borderRadius: "50%",
//   width: 12,
//   height: 12,
// });

export function CalendarDayAttendanceEvent(props: { child: Child; attendanceLog?: AttendanceLogEntry }) {
  const { child, attendanceLog } = props;
  const isSignedIn = !attendanceLog?.timeOutCentralDateTime;
  const isAbsent = !attendanceLog;
  let color: string = grey[500];
  if (isAbsent) {
    color = grey[500];
  } else if (isSignedIn) {
    color = green[500];
  } else {
    color = yellow[700];
  }
  const lastInitial = child.lastName.length > 0 ? child.lastName[0].toUpperCase() : "";
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <StatusDot color={color} />
      {child.firstName} {lastInitial}.
    </Stack>
  );
}
